import { StatCardProps } from "src/_pages/admin/components/statistical/star-card";
import {
  OrderStatisticsResponse,
} from "src/_pages/admin/interfaces/oms-interface";

export function mapOrderStatisticToHeader(
  statistic: OrderStatisticsResponse,
  rangeLabel = "Theo bộ lọc",
): StatCardProps[] {
  if (!statistic) return [];

  const monthlyData = statistic?.byMonth?.map((x) => x?.orderCount ?? 0) ?? [];
  const oderByStatus = (_status: string) =>
    `${statistic?.byStatus?.find((x) => x.status === _status)?.count ?? 0}`;

  return [
    {
      title: "Tổng đơn hàng",
      value: statistic?.totalOrders?.toLocaleString() ?? "",
      interval: rangeLabel,
      trend: "up",
      data: monthlyData,
    },
    {
      title: "Tổng doanh thu",
      value: statistic?.totalRevenue?.toLocaleString() ?? "",
      interval: rangeLabel,
      trend: "up",
      data: monthlyData,
    },
    {
      title: "Đơn đã duyệt",
      value: oderByStatus("ORDER_APPROVED") ?? '',
      interval: rangeLabel,
      trend: "up",
      data: monthlyData,
    },
    {
      title: "Đơn bị từ chối",
      value: oderByStatus("ORDER_REJECTED") ?? '',
      interval: rangeLabel,
      trend: "down",
      data: monthlyData,
    },
  ];
}
